export default "__VITE_ASSET__Bf$QbFFh__"